import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.html',
  styleUrl: './loader.scss'
})
export class Loader {
  @Input() isVisible = true;
  s3BaseUrl = environment.s3BaseUrl;

  getImageUrl(path: string): string {
    return `${this.s3BaseUrl}/${path}`;
  }
}
